import React from 'react'
import { SvgIcon } from '../svg-icon'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.DefaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}
/**
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WeatherSnowflakeIcon width={12} />
 */
export const WeatherSnowflakeIcon = props => (
    <SvgIcon {...props}>
        <path d="M20.25 9.75C20.05 9.75 19.875 9.675 19.725 9.525C19.575 9.375 19.5 9.2 19.5 9C19.5 8.78333 19.575 8.60417 19.725 8.4625C19.875 8.32083 20.05 8.25 20.25 8.25C20.4667 8.25 20.6458 8.32083 20.7875 8.4625C20.9292 8.60417 21 8.78333 21 9C21 9.2 20.9292 9.375 20.7875 9.525C20.6458 9.675 20.4667 9.75 20.25 9.75ZM10 22V18.05L7.15 20.9L6.1 19.85L10 15.95V14H8.05L4.15 17.9L3.1 16.85L5.95 14H2V12.5H5.95L3.1 9.65L4.15 8.6L8.05 12.5H10V10.55L6.1 6.65L7.15 5.6L10 8.45V4.5H11.5V8.45L14.35 5.6L15.4 6.65L11.5 10.55V12.5H19.5V14H15.55L18.4 16.85L17.35 17.9L13.45 14H11.5V15.95L15.4 19.85L14.35 20.9L11.5 18.05V22H10ZM19.5 6.75V2H21V6.75H19.5Z" />
    </SvgIcon>
)

WeatherSnowflakeIcon.defaultProps = defaultProps
